import { of } from 'rxjs';
import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { AuthService } from '../../../core/auth/auth.service';

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Check if initialized using signal
  if (!authService.isInitialized()) {
    // Store the redirect URL before waiting
    if (state.url !== '/login' && state.url !== '/') {
      authService.redirectUrl = state.url;
    }
    router.navigate(['/login']);
    return false;
  }

  // Check if authenticated using signal
  if (!authService.isAuthenticated()) {
    // Not authenticated → remember the desired URL, redirect to /login
    if (state.url !== '/login' && state.url !== '/') {
      authService.redirectUrl = state.url;
    }
    router.navigate(['/login']);
    return false;
  }

  // User is authenticated
  return true;
};
